import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
  FlatList,
} from "react-native";
import { Octicons } from "@expo/vector-icons";
import { FontAwesome } from "@expo/vector-icons";
import { getmission } from "../../action/actionGet";
import { useRecoilState } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { useIsFocused } from "@react-navigation/core";
import moment from "moment";
const { width, height } = Dimensions.get("window");
export default function tebleeventrank({ navigation, data }) {
  console.log(data);
  return (
    <View style={styles.back}>
      <View style={styles.head}>
        <View style={[styles.viewhead, { width: "35%" }]}>
          <Text style={styles.texthead}>รายการ</Text>
        </View>
        <View
          style={[styles.viewhead, { width: "25%"}]}
        >
          <Text style={styles.texthead}>วันที่สร้าง</Text>
        </View>
        <View style={[styles.viewhead, { width: "25%" }]}>
          <Text style={styles.texthead}>สถานะ</Text>
        </View>
        <View style={[styles.viewhead, { width: "15%" }]}>
          <Text style={styles.texthead}>ระยะทาง / กม.</Text>
        </View>
      </View>
      <FlatList
        data={data}
        
        renderItem={({ index, item }) => {
          return (
            <View>
              <View
                style={[
                  styles.viewmain,
                  { backgroundColor: index % 2 ? "#F1F2F4" : "#fff" },
                ]}
              >
                <TouchableOpacity
                  onPress={() => navigation.navigate("Userrank", { item })}
                  style={[
                    styles.viewdetail,
                    { width: "35%", justifyContent: "flex-start" },
                  ]}
                >
                  <Image
                    source={{
                      uri:
                        
                        item.img_title,
                    }}
                    style={styles.img}
                  />
                  <View>
                    <Text
                      numberOfLines={2}
                      style={[styles.textdeil, { width: "100%",marginLeft:10 }]}
                    >
                      {item.titel}
                    </Text>
                  </View>
                </TouchableOpacity>
                <View
                  style={[
                    styles.viewdetail,
                    { width: "25%",  },
                  ]}
                >
                  <Text style={[styles.textdate,{textAlign:"center"}]}>
                    {moment(item.updatedAt).format("DD/MM/YYYY")}
                  </Text>
                </View>
                <View style={[styles.viewdetail, { width: "25%" }]}>
                  <Octicons
                    name="dot-fill"
                    size={16}
                    color={item.status == "Active" ? "#2DCE98" : "red"}
                    style={{ alignSelf: "center", marginRight: 10 }}
                  />
                  <Text style={styles.textdate}>
                    {item.status == "Active " ? (
                      <Text style={styles.textdate}>Active</Text>
                    ) : (
                      <Text style={styles.textdate}>Inactive</Text>
                    )}
                  </Text>
                </View>
                <View style={[styles.viewdetail, { width: "15%" }]}>
                  <Text style={styles.textdate}>
                    {item?.distance?.[0]?.distance}
                  </Text>
                </View>
              </View>
            </View>
          );
        }}
      />
    </View>
  );
}
const styles = StyleSheet.create({
  back: {
    width: "100%",
    height: "82%",
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,

  },
  head: {
    width: "100%",
    height: 50,
    flexDirection: "row",
    backgroundColor: "#F1F3F9",
  },
  viewhead: {
    justifyContent: "center",
  },
  texthead: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewdetail: {
    flexDirection: "row",
    justifyContent: "center",
  },
  img: {
    width: 180,
    height: 80,
    zIndex: 99,
    marginLeft: -20,
  },
  textdeil: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#393939",
    marginTop: 5,
    marginLeft: -15,
  },
  textdetail: {
    fontFamily: "Prompt-Regular",
    fontSize: 12,
    color: "#393939",
    marginLeft: -15,
  },
  viewmain: {
    flexDirection: "row",
    width: "100%",
    height: 80,
    paddingHorizontal: 5,
  },
  textdate: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewatc: {
    width: width * 0.18,
    height: 30,
    justifyContent: "space-between",
    alignSelf: "flex-end",
    marginBottom: 20,
    flexDirection: "row",
    marginRight: 20,
  },
  touchatc: {
    width: 30,
    height: 30,
    borderRadius: 15,
    borderWidth: 0.5,
    borderColor: "#8898AA",
    justifyContent: "center",
  },
  textatc: {
    fontFamily: "Prompt-Regular",
    fontSize: 15,
    color: "#7764E4",
    alignSelf: "center",
  },
  touchedit: {
    width: 80,
    height: 30,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    alignSelf: "center",
    justifyContent: "center",
    marginLeft: -80,
  },
});
